export interface RuntimeConfig {
  /** Keycloak realm URL, e.g. http://localhost:8080/realms/brig */
  oidcAuthority: string;
  oidcClientId: string;
  /** API origin; empty means same origin (dev proxy / nginx reverse proxy). */
  apiBaseUrl: string;
}

declare global {
  interface Window {
    __BRIG_CONFIG__?: Partial<RuntimeConfig>;
  }
}

export function readConfig(source: Partial<RuntimeConfig> | undefined): RuntimeConfig {
  const authority = source?.oidcAuthority;
  const clientId = source?.oidcClientId;
  if (!authority || !clientId) {
    throw new Error(
      'Runtime configuration is missing: /config.js must define oidcAuthority and oidcClientId',
    );
  }
  return {
    oidcAuthority: authority.replace(/\/$/, ''),
    oidcClientId: clientId,
    apiBaseUrl: (source.apiBaseUrl ?? '').replace(/\/$/, ''),
  };
}

export const config = readConfig(typeof window === 'undefined' ? undefined : window.__BRIG_CONFIG__);
